<template>
    <div class="contacts-wrap" :class="getCurThemeType=='enWrap' ? 'enWrap-font-wrap':''">
      <div class="page1-wrap page-same">
				<div class="w">
					<div class="lark-logo">
						<img src="../../assets/img/contacts/lark-logo.png" alt="">
					</div>
					<div class="title" v-html="$t('contact.page1Title')"></div>
					<div class="pic"></div>
				</div>
      </div>

			<div class="page2-wrap same">
				<div class="reserve-box">
					<div class="title">{{$t('contact.tableText1')}}</div>
					<div class="text">{{$t('contact.tableText2')}}</div>
						<el-form :model="userInfo" ref="addFormRef" :rules="rules" class="demo-ruleForm">
							<div class="ruleForm-a">
								<div class="col">
									<el-form-item prop="title" :label="$t('contact.tableText8')">
										<el-select v-model="userInfo.title" :placeholder="this.$t('base.select')">
											<el-option
												v-for="item in options1"
												:key="item.value"
												:label="$t('contact.' + item.label)"
												:value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="col">
									<el-form-item prop="name" :label="$t('contact.tableText3')">
										<el-input  v-model="userInfo.name"> </el-input>
									</el-form-item>
								</div>
								<div class="col">
									<el-form-item prop="iphone" :label="$t('contact.tableText4')">
										<el-input  v-model="userInfo.iphone"> </el-input>
									</el-form-item>
								</div>
								<div class="col">
									<el-form-item prop="email" :label="$t('contact.tableText5')">
										<el-input  v-model="userInfo.email"> </el-input>
									</el-form-item>
								</div>
							</div>

							<div class="ruleForm-b">
								<div class="col">
									<el-form-item prop="city" :label="$t('contact.tableText9')">
										<el-input  v-model="userInfo.city"> </el-input>
									</el-form-item>
								</div>
								<div class="col">
									<el-form-item prop="country" :label="$t('contact.tableText10')">
										<el-input  v-model="userInfo.country"> </el-input>
									</el-form-item>
								</div>
								<div class="col">
									<el-form-item prop="referrer" :label="$t('contact.tableText11')">
										<el-input  v-model="userInfo.referrer"> </el-input>
									</el-form-item>
								</div>
							</div>

							<div class="ruleForm-c">
								<div class="col">
									<el-form-item prop="desired" :label="$t('contact.tableText12')">
										<el-select v-model="userInfo.desired" :placeholder="this.$t('base.select')">
											<el-option
												v-for="item in options2"
												:key="item.value"
												:label="$t('contact.' + item.label)"
												:value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="col">
									<el-form-item prop="problem" :label="$t('contact.tableText13')">
										<el-select v-model="userInfo.problem" :placeholder="this.$t('base.select')">
											<el-option
												v-for="item in options3"
												:key="item.value"
												:label="$t('contact.' + item.label)"
												:value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="col">
									<el-form-item prop="preferred" :label="$t('contact.tableText14')">
										<el-select v-model="userInfo.preferred" :placeholder="this.$t('base.select')">
											<el-option
												v-for="item in options4"
												:key="item.value"
												:label="$t('contact.' + item.label)"
												:value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							</div>

							<div class="ruleForm-d">
								<div class="col col-4">
									<el-form-item prop="age" :label="$t('contact.tableText6')">
										<el-input
											type="textarea"
											:rows="2"
											resize="none"
											v-model="userInfo.help">
										</el-input>
									</el-form-item>
								</div>
								<div class="col col-btn">
									<div class="title">
										<i class="iconfont icon-baomishebei"></i>
										<span v-html="$t('contact.tableText7')"></span>
									</div>
									<el-button type="primary" @click="submitForm">{{$t('contact.submit')}}</el-button>
								</div>
							</div>
						</el-form>
				</div>
			</div>

			<div class="page3-wrap same"></div>

			<div class="page4-wrap same">
				<div class="w">
					<!-- <div class="title">{{$t('contact.title')}}</div> -->
					<div class="box-wrap">
						<div class="map">
							<img src="../../assets/img/home/map2.jpg" alt="">
						</div>
						<div class="customized">
							<div class="list-wrap">
								<div class="item-wrap" v-for="(item,index) in contactList" :key="index" :class="'item'+ index">
									<div class="pic"><img :src="item.pic" alt=""></div>
									<div class="r-wrap">
										<div class="title-item">{{$t('contact.' + item.title)}}</div>
										<div class="text-item" v-html="$t('contact.'+ item.text)"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

    </div>
</template>

<script>
		import page1Src  from '@/assets/img/home/map.png'
    export default {
        name: "technogy",
        metaInfo: {
            title: 'KrngPartners', // set a title
            meta: [{             // set meta
                name: 'keyWords',
                content: ''
            },
            {
                name: 'description',
                content: ''
            }]
        },
        data() {
						// 验证手机号规则
						let checkMobile = (rule,value,callback)=>{
								// 正则表达式
								const ragMobile = /^(13[0-9]|14[0-9]|15[0-9]|166|17[0-9]|18[0-9]|19[8|9])\d{8}$/;
								if (ragMobile.test(value)) {
									// 合法手机号
									return callback()
								}
								callback(new Error(this.$t('messages.error1')))
						}
						// 验证邮箱规则
						let checkEmail = (rule,value,callback)=>{
								// 正则表达式
								const ragEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
								if (ragEmail.test(value)) {
									// 合法邮箱
									return callback()
								}
								callback(new Error(this.$t('messages.error2')))
						}
            return {
							userInfo:{
									title:'',
									name:'',
									iphone:'',
									email:'',
									help:'',
									city:'',
									country:'',
									referrer:'',
									desired:'',
									problem:'',
									preferred:''
							},
							rules:{
									title: [
										{ required: true, message: this.$t('messages.title'), trigger: 'blur' },
									],
									name: [
										{ required: true, message: this.$t('messages.errorName'), trigger: 'blur' },
									],
									iphone: [
										{ required: true, message: this.$t('messages.errorIphone'), trigger: 'blur' },
										{  validator:checkMobile,trigger: 'blur'}
									],
									email: [
										{ required: true, message: this.$t('messages.errorEmail'), trigger: 'blur' },
										{  validator:checkEmail,trigger: 'blur'}
									],
									city: [
										{ required: true, message: this.$t('messages.error3'), trigger: 'blur' },
										{  validator:checkEmail,trigger: 'blur'}
									],
									country: [
										{ required: true, message: this.$t('messages.error4'), trigger: 'blur' },
										{  validator:checkEmail,trigger: 'blur'}
									],
									referrer: [
										{ required: true, message: this.$t('messages.error5'), trigger: 'blur' },
										{  validator:checkEmail,trigger: 'blur'}
									],
									desired: [
										{ required: true, message: this.$t('messages.error6'), trigger: 'blur' },
										{  validator:checkEmail,trigger: 'blur'}
									],
									problem: [
										{ required: true, message: this.$t('messages.error7'), trigger: 'blur' },
										{  validator:checkEmail,trigger: 'blur'}
									],
									preferred: [
										{ required: true, message: this.$t('messages.error8'), trigger: 'blur' },
										{  validator:checkEmail,trigger: 'blur'}
									],
							},
							page1Src:page1Src,
							contactList:[
							{title:'title1',text:'text1',pic:require('../../assets/img/home/internet.png')},
							{title:'title2',text:'text2',pic:require('../../assets/img/home/mail.png')},
							{title:'title3',text:'text4',pic:require('../../assets/img/home/location.png')},
     				 ],
							options1:[
								{value:'Mr',label:'tableText15'},
								{value:'Ms',label:'tableText16'},
							],
							options2:[
								{value:'Urgent',label:'tableText17'},
								{value:'Fast',label:'tableText18'},
								{value:'Standard',label:'tableText19'},
							],
							options3:[
								{value:'188ab',label:'tableText20'},
								{value:'188c',label:'tableText21'},
								{value:'888a',label:'tableText22'},
								{value:'888b',label:'tableText23'},
								{value:'888c',label:'tableText24'},
								{value:'Others',label:'tableText25'},
							],
							options4:[
								{value:'Written',label:'tableText26'},
								{value:'Audio',label:'tableText27'},
								{value:'Video',label:'tableText28'},
							]
            }
        },
        computed: {


        },
        components: {

        },
        created(){

        },

        methods: {
					submitForm(){
						this.$refs.addFormRef.validate(async valid => {
							if(!valid) return
						})
					}
        },
        mounted() {

        },
    }
</script>

<style lang="scss" scoped>
    @import "contacts.scss";
</style>
